import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import SignUpModal from '../components/modals/SignUpModal';
// import { GraduationCap } from 'lucide-react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // const navigationItems = [
  //   {
  //     name: 'Learning Path',
  //     href: '/vbc-learning-path',
  //     icon: <GraduationCap className="w-5 h-5" />,
  //   },
  // ];

  return (
    <>
      <header 
        className={`fixed w-full top-0 z-50 transition-all duration-300 ${
          isScrolled 
            ? 'bg-white/80 backdrop-blur-md shadow-sm' 
            : 'bg-white/20 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <nav className="flex items-center space-x-8">
              <Link 
                to="/" 
                className={`transition-colors duration-200 font-medium ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-primary' 
                    : 'text-gray-800 hover:text-primary'
                }`}
              >
                Home
              </Link>
              {/* <Link 
                to="/homeschool" 
                className={`transition-colors duration-200 font-medium ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-primary' 
                    : 'text-gray-800 hover:text-primary'
                }`}
              >
                For Homeschoolers
              </Link> */}
              {/* <Link 
                to="/alt" 
                className={`transition-colors duration-200 font-medium ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-primary' 
                    : 'text-gray-800 hover:text-primary'
                }`}
              >
                Alt Home
              </Link> */}
              <Link 
                to="/blog" 
                className={`transition-colors duration-200 font-medium ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-primary' 
                    : 'text-gray-800 hover:text-primary'
                }`}
              >
                Blog
              </Link>
              <Link 
                to="/vbc-online" 
                className="transition-colors duration-200 font-medium inline-flex flex-col items-center"
              >
                <div className="relative">
                  <span className={`${
                    isScrolled ? 'text-gray-700 hover:text-primary' : 'text-gray-800 hover:text-primary'
                  }`}>
                    VBC Online
                  </span>
                  <span className="bg-green-100 text-green-800 text-[10px] px-1.5 py-0.5 rounded-full font-medium animate-pulse absolute -top-3 -right-5 whitespace-nowrap">
                    Sign Up
                  </span>
                </div>
              </Link>

              <Link 
                to="/vbc-learning-path" 
                className="transition-colors duration-200 font-medium inline-flex flex-col items-center"
              >
                <div className="relative">
                  <span className={`${
                    isScrolled ? 'text-gray-700 hover:text-primary' : 'text-gray-800 hover:text-primary'
                  }`}>
                    VBC Venture
                  </span>
                  <span className="bg-yellow-100 text-yellow-800 text-[10px] px-1.5 py-0.5 rounded-full font-medium animate-pulse absolute -top-3 -right-7 whitespace-nowrap">
                    Coming Soon
                  </span>
                </div>
              </Link>
            </nav>

            {/* <button 
              onClick={() => setIsModalOpen(true)}
              className={`px-4 py-2 rounded-full font-medium transition-all duration-200 ${
                isScrolled
                  ? 'bg-primary text-white hover:bg-blue-700'
                  : 'bg-primary text-white hover:bg-blue-700'
              }`}
            >
              Sign Up
            </button> */}
          </div>
        </div>
      </header>

      <SignUpModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
